import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import LeaveDaysIndexContainer from '../containers/LeaveDays/LeaveDaysIndexContainer'
import LeaveDayFormContainer from '../containers/LeaveDays/LeaveDayFormContainer'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const LeaveDaysPage = ({
  location,
  match
}) => {
  const dispatch = useDispatch()
  const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
  const { pathname } = location

  useEffect(() => {
    if (current[0] !== 'leave_days') {
      dispatch(changeCurrent(['leave_days']))
    }
  }, [pathname])

  const path = match.url

  return (
    <Switch>
      <Route path={`${path}/`} component={LeaveDaysIndexContainer} exact />
      <Route path={`${path}/new`} component={LeaveDayFormContainer} />
      <Route path={`${path}/:id/edit`} component={LeaveDayFormContainer} />
    </Switch>
  )
}

LeaveDaysPage.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

LeaveDaysPage.defaultProps = {}

export default LeaveDaysPage
